import { useSelector } from 'react-redux';
import {
  getCurrentAccount,
  selectIsSellFromHomeRestricted,
  selectPrimaryAccountUser,
} from '../../store/selectors/accountSelectors';
import { selectAuthUser } from '../../store/selectors/userSelectors';
import { accountTypes, accountTypeKeys } from '../enum/api/accountTypes';
import { accountCountryTypes } from '../enum/api/accountCountryTypes';
import { parseEnumType } from '../helpers/enumMappers';
import {
  isJointAccountType,
  resolveIsPrimaryUser,
} from '../../constants/sfhIrsCopy';
import config from '../../config';
import { GS } from '../../constants/Brokers';

const useSellFromHomeEligibility = () => {
  const account = useSelector(getCurrentAccount);
  const isSellFromHomeRestricted = useSelector(selectIsSellFromHomeRestricted);
  const authUser = useSelector(selectAuthUser);
  const primaryAccountUser = useSelector(selectPrimaryAccountUser);

  const isGS = config.brokerTheme === GS;
  const isNonUS = account?.Country === accountCountryTypes.NonUS;
  const accountType = parseEnumType(accountTypeKeys, account?.AccountType);
  const isBasicAccount = accountType === accountTypes.Basic;
  const isIraOrUtmaAccount =
    accountType === accountTypes.IRA || accountType === accountTypes.UTMA;
  const isPendingAccount =
    account?.AccountStatus === 4 ||
    account?.AccountStatus === 1 ||
    account?.AccountStatus === 7;
  // Same gate as SFH IRS named-primary copy: joint secondary only.
  const isJointSubUser =
    isJointAccountType(accountType) &&
    resolveIsPrimaryUser({ authUser, primaryAccountUser }) === false;

  return {
    isGS,
    isNonUS,
    isBasicAccount,
    isIraOrUtmaAccount,
    isJointSubUser,
    isPendingAccount,
    isSellFromHomeRestricted,
  };
};

export default useSellFromHomeEligibility;
